import { Button } from "PFComponents/button";
import { Typography } from "PFComponents/typography";
import { RollforwardReference } from "PFCore/types";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

type RollForwardActivityProps = {
  rollForwardReference: RollforwardReference;
  mode?: "button" | "link";
  onClick?: () => void;
};

export const RollForwardActivity = ({
  rollForwardReference,
  mode = "button",
  onClick
}: RollForwardActivityProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.details.rollforward" });

  const { id, name } = rollForwardReference;
  const activityLabel = t("activityLabel", { id, name });

  if (mode === "link") {
    return (
      <Link to={`/activities/${id}`}>
        <Typography variant="bodyBold" tag="span">
          {activityLabel}
        </Typography>
      </Link>
    );
  }

  return (
    <Button kind="text" onClick={onClick}>
      <Typography variant="bodyBold">{activityLabel}</Typography>
    </Button>
  );
};
